export default __webpack_public_path__ + "static/media/logo-white.35e63338.svg";